// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-control[data-v-6019b8ea] {\n  border-radius: 1px;\n}\ntable tr td[data-v-6019b8ea] {\n  padding-bottom: 1em;\n}\ntable tr td.h-align-end[data-v-6019b8ea] {\n  text-align: right;\n  padding-right: 1em;\n}\ntable tr td[data-v-6019b8ea]:first-child {\n  width: 96px;\n}", ""]);
// Exports
module.exports = exports;
